<template>
  <pt-notice-manage class="pt-notice-manage__page"></pt-notice-manage>
</template>

<script>
import PtNoticeManage from 'cps/information-manage/pt-notice-manage/withData'
export default {
  name: 'pt-notice-manage__view',
  components: {
    'pt-notice-manage': PtNoticeManage
  }
}
</script>
